import { PermanentJobsApi } from '../clients';
import { IRetryBillingResultEntity } from '../types';

export const retryBilling = async (officeId?: string): Promise<IRetryBillingResultEntity[]> => {
  return PermanentJobsApi.retryBilling(officeId);
};
